import Env from '../base/env'
import gsap from 'gsap'

export default class MainTransition
{
    constructor()
    {
      this.view = Env.$mainTransition
      this.settings = { easing : 'quint.out' , duration : .4 }
      this.direction = false
      this.status = false
      this.setDirection(-1)
    }

    getStatus()
    {
        return this.status
    }

    out(funcStart='',funcComplete='')
    {
      let timeline = gsap.timeline({
        onStart:()=>{
          this.status = 'animating'
          if(typeof funcStart == 'function' || funcStart != null) funcStart()
        },
        onComplete:()=>{
          this.status = 'in'
          if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
        }
      })

      console.log('out');

      timeline.add([
        // gsap.fromTo(Env.$mainTransitionProgress , 1, { scaleX : 0 , transformOrigin : 'left top' } , { scaleX : 1 , ease : Power3.easeInOut }),
        gsap.fromTo(this.view , .7,
          {
              autoAlpha:0,
              // y : '100%'
          },
          {
            autoAlpha:1,
              // y : 0,
              ease: 'cubic.inOut',
              delay: 0,
          }
        )
      ])
    }

    in(funcStart='',funcComplete='')
    {
      let timeline = gsap.timeline({
        onStart:()=>{
            this.status = 'animating'
            if(typeof funcStart == 'function' || funcStart != null) funcStart()
        },
        onComplete:()=>{
            this.status = 'out'
            if(typeof funcComplete == 'function' || funcComplete != null) funcComplete()
        }
      })
      const goTo = (this.direction > 0)?'100%':'-100%'
      timeline.add([
        // gsap.fromTo(Env.$mainTransitionProgress , 1 , { transformOrigin : 'right top' } , { scaleX : 0 , ease : Power3.easeInOut }),
        gsap.fromTo(this.view , .3,
            {
                autoAlpha:1,
                // y : 0
            },
            {
              autoAlpha:0,
                // y : '-100%',
                ease: 'cubic.inOut',
                delay: 0,
            }
          )
        ])
    }

    setDirection(value)
    {
        this.direction = value
    }
}
